module.exports = __webpack_public_path__ + "assets/src/style/img/svg/icons/category-film.svg?51292dbc48f88641f1d7fb67f198bc16";